import { Box } from '@mui/material';
import React from 'react';
import {
  Typography700,
  ExpandableDescriptionV2,
} from 'views/rebranded-module/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/TourInformationsSection/TourInformationsSection.styles';
import { RiArrowRightSLine } from 'react-icons/ri';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';

const TourInformationsSection = (props) => {
  const { cmsData, tour, isOffroad } = props;
  return (
    <StyledBox>
      <Box mb={2} display="flex" alignItems="center">
        <Typography700
          variant="overline2"
          color="primary"
          component={NavigatorLink}
          href={PATHS.locationSlug(tour.start_location.slug)}>
          {tour.start_location.name}
        </Typography700>
        <Box px={0.75} display="flex" alignItems="center">
          <RiArrowRightSLine className="TISArrowIcon" size={16} />
        </Box>
        <Typography700
          variant="overline2"
          color="primary"
          component={NavigatorLink}
          href={PATHS.locationSlug(tour.end_location.slug)}>
          {tour.end_location.name}
        </Typography700>
      </Box>
      {tour.subtitle && (
        <Typography700 variant="h5" component="p" mb={3}>
          {tour.subtitle}
        </Typography700>
      )}
      <Typography500 variant="body2" component="p" mb={3} className="TISubInfo">
        {isOffroad
          ? tour.tagline
          : interpolateString(cmsData.TourDetailsPage.daysAndNightDisplay, {
            days: tour.days_count,
            nights: tour.days_count - 1,
          })}
        {' • '}
        {tour.tour_type.name}
        {' • '}
        {interpolateString(cmsData.TourDetailsPage.distanceDisplay, {
          miles: tour.distance.miles,
          km: tour.distance.km,
        })}
        {' • '}
        {interpolateString(cmsData.TourDetailsPage.tempDisplay, {
          f: `${tour.temperature.fahrenheit.low} - ${tour.temperature.fahrenheit.high}`,
          c: `${tour.temperature.celsius.low} - ${tour.temperature.celsius.high}`,
        })}
      </Typography500>
      <ExpandableDescriptionV2
        description={tour.description}
        collapsedSize={72}
        content={cmsData.ExpandableSectionComponent}
        autoExpand={isOffroad}
      />
    </StyledBox>
  );
};

export { TourInformationsSection };
